import { isAvailable, isLocked } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import { reduceSidebarLockedFeaturesTest } from "app/components/sidebar3/secondary-side-bar/utils";
import type { INavItem } from "app/components/sidebar3/types";
import { applyNavItemPermissions } from "app/pages/workspace/common/workspacesUtils";

export const searchTrackingNavObj = (): { navList: INavItem[] } => {
    return {
        navList: [
            {
                title: "digitalsuite.rank.tracker.title",
                name: "keywords_report",
                state: "ranktracker.home",
                subItems: [
                    {
                        title: "digitalsuite.rankTracker.homepage",
                        name: "Overview",
                        state: "ranktracker.home",
                    },
                    {
                        title: "digitalsuite.rankTracker.overview.title",
                        name: "Overview",
                        state: "ranktracker.overview",
                    },
                    {
                        title: "common.keywords",
                        name: "Keywords",
                        state: "ranktracker.keywords",
                        defaultQueryParams: {
                            MainSitePositionTrend: null,
                        },
                    },
                    {
                        title: "RT.Trend.sidebar.title",
                        name: "Trend",
                        state: "ranktracker.trend",
                    },
                    {
                        title: "digitalsuite.tags",
                        name: "Tags",
                        state: "ranktracker.tags",
                        menuItemComponentProps: {
                            iconName: "sidebar3-website-analysis",
                            "data-automation-section": "digitalsuite.tags",
                        },
                    },
                    {
                        title: "digitalsuite.pages",
                        name: "Pages",
                        state: "ranktracker.pages",
                        menuItemComponentProps: {
                            iconName: "sidebar3-website-analysis",
                            "data-automation-section": "digitalsuite.pages",
                        },
                    },
                    {
                        title: "digitalsuite.seo.rankTracker.competitors.title",
                        name: "Competitors",
                        state: "ranktracker.competitors",
                        menuItemComponentProps: {
                            iconName: "sidebar3-website-analysis",
                            "data-automation-section": "digitalsuite.competitors",
                        },
                    },
                    {
                        title: "digitalsuite.seo.rankTracker.serpFeature.title",
                        name: "Serp feature report",
                        state: "ranktracker.serpfeatures",
                        menuItemComponentProps: {
                            iconName: "sidebar3-website-analysis",
                            "data-automation-section": "digitalsuite.serpFeature",
                        },
                    },
                ],
            },
            {
                title: "digitalsuite.ads.tracker.title",
                name: "adsTracker",
                state: "brandmonitoring.home",
                hidden: !isAvailable(swSettings.components.BrandMonitor),
                subItems: [
                    {
                        title: "digitalsuite.rankTracker.homepage",
                        name: "Overview",
                        state: "brandmonitoring.home",
                        lockIcon: isLocked(swSettings.components.BrandMonitor),
                    },
                    {
                        title: "brand.monitoring.reports.advertisers.title",
                        name: "Advertisers",
                        state: "brandmonitoring.competitors",
                        lockIcon: isLocked(swSettings.components.BrandMonitor),
                    },
                    {
                        title: "brand.monitoring.reports.searchAds.title",
                        name: "searchAds",
                        state: "brandmonitoring.searchads",
                        lockIcon: isLocked(swSettings.components.BrandMonitor),
                    },
                ],
            },
        ]
            .map(applyNavItemPermissions)
            .reduce(reduceSidebarLockedFeaturesTest, []) as INavItem[],
    };
};
